/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PurchaseOrderDetailInsert { 
    /**
     * A reference to the primary key in the PurchaseOrderHeaders Table
     */
    purchaseOrderHeaderId: number;
    /**
     * A reference to the primary key in the Stock Table
     */
    stockId: number;
    /**
     * A reference to the primary key in the SupplierInventoryCodes Table
     */
    supplierInventoryCodeId?: number;
    unitType?: PurchaseOrderDetailInsert.UnitTypeEnum;
    /**
     * A reference to the primary key in the Factors Table
     */
    factorId?: number;
    unitQtyToOrder: number;
    /**
     * The unique external key set by the current user accessing the API
     */
    externalKey?: string;
    qtyInStock?: number;
    qtyRequired?: number;
    qtyOnOrder?: number;
}
export namespace PurchaseOrderDetailInsert {
    export type UnitTypeEnum = 'Factor' | 'Inner' | 'Outer';
    export const UnitTypeEnum = {
        Factor: 'Factor' as UnitTypeEnum,
        Inner: 'Inner' as UnitTypeEnum,
        Outer: 'Outer' as UnitTypeEnum
    };
}